/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useForm, FormProvider } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import { object, bool, string, func, arrayOf, PropTypes } from 'prop-types';

// Helper
import { schemaForEditOccasion } from '../../Helpers/Schema';

// MUI
import { Divider, Grid } from '@material-ui/core';

// Component
import EditOccasions from './EditOccasions';
import { useSelector } from 'react-redux';
import { getFeatureFlag } from '../../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';


const EditOccasionsContainer = ({ occasions, classes, rcpId, rcpFirstName, rcpLastName, isParentDesktopComponent, selectedOccasionId, getUpdatedOccasions, sortedOccasions }) => {
    const methods = useForm({ mode: 'all', defaultValues: { occasions }, resolver: joiResolver(schemaForEditOccasion) });
    const watchOccasions = methods.watch('occasions');
    const isShowingReminderPreferences = useSelector(getFeatureFlag('sms-reminder-notification-preferences'));

    useEffect(() => {
      getUpdatedOccasions(watchOccasions);
    }, [watchOccasions]);

    return (
        <FormProvider {...methods}>
          <form>
            {isShowingReminderPreferences && <Grid item xs={12}>
                <div>
                    <p className={classes.sectionTitle}>Reminders</p>
                    <p className={classes.sectionInfo}>Receive timely reminder notifications sent seamlessly to your email. Want reminders sent by text? <Link to="/account/email-preference">Tap here.</Link></p>
                </div>
            </Grid>}
            <Divider className={classes.dividerStyle} />
            {watchOccasions?.map((occ, index) => {
              // We don't want to show additional occasions that haven't been saved
              // We can identify this type of occasion by checking for the rcpId
              // We also need to make sure we show Birthday because it is a default occasion - even though it does not have a rcpId by default
              if (!occ.rcpId && occ.occasion !== '2') return null;
              // We hide existing Wedding occasions to merge them into Anniversaries on the BE
              if (occ.occasion === '3') return null;
              return (
                <EditOccasions
                  key={`${index}-${occ?.occasionId || occ?.occasion}-${occ?.rcpId}`}
                  classes={classes}
                  occ={occ}
                  index={index}
                  occasions={occasions}
                  rcpId={rcpId}
                  rcpFirstName={rcpFirstName}
                  rcpLastName={rcpLastName}
                  sortedOccasions={sortedOccasions}
                  isParentDesktopComponent={isParentDesktopComponent}
                  selectedOccasionId={selectedOccasionId}
              />)})}
          </form>
        </FormProvider>
    );
};

EditOccasionsContainer.propTypes = {
  rcpId: string.isRequired,
  classes: object.isRequired,
  occasions: arrayOf(PropTypes.shape({
    desc: string,
    rcpId: string,
    dateDD: string,
    dateMM: string,
    dateYYYY: string,
    subscribed: bool,
    occasion: string,
    occasionId: string,
    createdDate: string,
    createdUser: string,
    reminderEmail: string,
    reminderPhone: string,
    subscribedEmail: bool,
    subscribedPhone: bool,
  })),
  rcpLastName: string.isRequired,
  rcpFirstName: string.isRequired,
  sortedOccasions: arrayOf(PropTypes.shape({
    desc: string,
    rcpId: string,
    dateDD: string,
    dateMM: string,
    dateYYYY: string,
    subscribed: bool,
    occasion: string,
    occasionId: string,
    createdDate: string,
    createdUser: string,
    reminderEmail: string,
    reminderPhone: string,
    subscribedEmail: bool,
    subscribedPhone: bool,
  })),
  selectedOccasionId: string.isRequired,
  getUpdatedOccasions: func.isRequired,
  isParentDesktopComponent: bool.isRequired,
};

export default EditOccasionsContainer;
